export const indiaCurrency = "₹";
export const getTotalAmount = (items) => {
  return items.reduce(
    (amount, item) => item.product.discountPrice * item.quantity + amount,
    0
  );
};
export const tax = 0;
export const getAverageReview = (reviews) => {
  let sumReview = reviews.reduce((sum, review) => {
    return sum + review.rating;
  }, 0);
  return sumReview / reviews.length;
};
